module.exports = __webpack_public_path__ + "zvetseni-prsou_59_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_59_before.jpg
// module id = 1354
// module chunks = 0